module.exports = __webpack_public_path__ + "static/img/8areaA_14.915794c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/8areaA_14.png
// module id = 981
// module chunks = 1